enum CookieName {
  Auth = "auth",
  BrowserIsNotSupported = "browserIsNotSupported",
  Locale = "locale",
  Nonce = "nonce",
}

export default CookieName;
